<div class="page-container">
  <app-nav></app-nav>

  <main class="main-content">
    <div class="content-wrapper">

      <header class="page-header">
        <h1 class="page-title">Cuaderno de Recibos</h1>
      </header>

      <div class="filter-card">
        <div class="filter-grid">

          <label class="filter-group">
            <span class="label-text">Fecha</span>
            <div class="input-wrapper">
              <span class="material-symbols-outlined input-icon">calendar_today</span>
              <input type="date" class="form-input" [(ngModel)]="filtroFecha" />
            </div>
          </label>

          <div class="filter-actions">
            <button class="btn btn-secondary" (click)="limpiarFiltros()">Limpiar</button>
            <button class="btn btn-primary" (click)="aplicarFiltros()">Aplicar</button>
          </div>

        </div>
      </div>

      <div class="table-card">
        <div class="table-responsive">
          <table class="orders-table">
            <thead>
              <tr>
                <th>No. Venta</th>
                <th>Hora</th>
                <th>Cliente</th>
                <th>Método Pago</th>
                <th>Vendedor</th>
                <th class="text-right">Total</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let venta of historialVentas; let i = index">
                <td class="font-medium"># {{ venta.id_venta }}</td>
                <td>{{ venta.hora | slice:0:5 }}</td>
                <td>{{ venta.cliente_nombre }}</td>
                <td>
                  <span class="badge"
                    [ngClass]="{'bg-lista': venta.metodo_pago === 'Efectivo', 'bg-proceso': venta.metodo_pago !== 'Efectivo'}">
                    {{ venta.metodo_pago }}
                  </span>
                </td>
                <td class="font-medium" style="color: #9ca3af;">
                  {{ obtenerNombreVendedor(venta) }}
                </td>
                <td class="text-right font-medium" style="color: #00e676;">$ {{ venta.total | number }}</td>
                <td class="text-center">
                  <div class="action-buttons">
                    <button class="btn-icon" title="Ver Detalles" (click)="toggleDetalles(i)" [attr.aria-label]="'Ver detalles de venta ' + venta.id_venta">
                      <span class="material-symbols-outlined">visibility</span>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let venta of historialVentas; let i = index">
                <td colspan="7" style="padding:0; border: none; background: #23272b;">
                  <table *ngIf="venta.detalles && venta.detalles.length > 0 && detallesVisibles[i]" style="width:100%; margin-bottom: 1.5rem; background: #23272b;">
                    <thead>
                      <tr style="background: #23272b; color: #9ca3af; font-size: 0.95em;">
                        <th style="padding: 0.5rem 0.5rem;">Producto</th>
                        <th style="padding: 0.5rem 0.5rem;">Categoría</th>
                        <th style="padding: 0.5rem 0.5rem;">Proveedor</th>
                        <th style="padding: 0.5rem 0.5rem;">Cantidad</th>
                        <th style="padding: 0.5rem 0.5rem;">Precio</th>
                        <th style="padding: 0.5rem 0.5rem;">Subtotal</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let det of venta.detalles">
                        <td style="padding: 0.5rem 0.5rem; color: #fff;">{{ det.nombre_producto }}</td>
                        <td style="padding: 0.5rem 0.5rem;">{{ det.categoria }}</td>
                        <td style="padding: 0.5rem 0.5rem;">{{ det.proveedor }}</td>
                        <td style="padding: 0.5rem 0.5rem; text-align:center;">{{ det.cantidad_vendida }}</td>
                        <td style="padding: 0.5rem 0.5rem; text-align:right;">$ {{ det.precio_unitario | number }}</td>
                        <td style="padding: 0.5rem 0.5rem; text-align:right;">$ {{ det.subtotal | number }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr *ngIf="historialVentas.length === 0">
                <td colspan="7" class="text-center" style="padding: 2rem; color: #9ca3af;">
                  No hay ventas registradas en esta fecha.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="total-summary-card">
        <div class="summary-container" style="justify-content: flex-end; gap: 2rem;">
          <div class="total-wrapper">
            <label class="total-label">Total del Día:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" [value]="'$ ' + (totalDelDia | number)" readonly />
            </div>
          </div>
          <div class="total-wrapper">
            <label class="total-label" style="color:#00e676">Efectivo:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" [value]="'$ ' + (totalEfectivo | number)" readonly />
            </div>
          </div>
          <div class="total-wrapper">
            <label class="total-label" style="color:#2196f3">Transferencia:</label>
            <div class="input-wrapper-simple">
              <input type="text" class="total-input" style="color:#2196f3;" [value]="'$ ' + (totalTransferencia | number)" readonly />
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>